import React, { useState } from "react";
import "./campaigncard.css";
import MessageModal from "./MessageModal";

const MessageCard = ({cardData}) => {
  const [messageModal, setMessageModal] = useState(false);

  const toggleMessageModal = () => {
    setMessageModal(!messageModal);
  };

  return (
    <>
      <div className="campaign-card card--gameboard-card item-card">
        <div className="campaign-card__header">
          <div className="campaign-card__title-wrapper">
            <span className="details-icon">
              <svg
                viewBox="0 0 19 20"
                xmlns="http://www.w3.org/2000/svg"
                className="menu-icon__svg"
                preserveAspectRatio="xMidYMid meet"
                style={{ width: "20px", height: "20px" }}
              >
                <path d="M3.25 0A3.254 3.254 0 000 3.25v11.018a1.246 1.246 0 001.251 1.25c.259 0 .516-.08.734-.239L6.493 12h6.257A3.254 3.254 0 0016 8.75v-5.5A3.254 3.254 0 0012.75 0h-9.5zM17 4.01v4.74A4.253 4.253 0 0112.75 13H6.82l-2.225 1.615A3.245 3.245 0 007.25 16h6.255l4.51 3.28a1.242 1.242 0 001.3.1c.425-.21.685-.64.685-1.11V7.25a3.258 3.258 0 00-3-3.24z"></path>
              </svg>
            </span>
            <div className="campaign-card__title">Message</div>
          </div>
        </div>
        <div className="campaign-card__content">
          <div className="card--item--type">Email</div>
          <div className="campaign-card--description details">{cardData?.message?.subject ? cardData?.message?.subject.substr(0,30) + "..." : ""}</div>
        </div>
        <div className="campaign-card__action__footer">
          <button className="campaign-button" onClick={toggleMessageModal}>
            <span class="campaign-button__label">Edit</span>
          </button>
        </div>
      </div>
      <MessageModal isOpen={messageModal} onClose={toggleMessageModal} cardData={cardData} />
    </>
  );
};

export default MessageCard;
